import o from"../font/index.js";var a={defaults:{variant:"body2",color:o.defaults.color}};export{a as default};
